import React, { useEffect } from "react";
import Editor from "@monaco-editor/react";
import { disablePaste } from "utils/general";
import { developmentFlag } from "constants/common";

const CodeEditorWindow = ({ onChange, language, code, theme }) => {

  const inFrame = window.location !== window.parent.location;
  useEffect(() => {
    if (!inFrame) return;
    const editorElement = document.getElementById("editor");
    editorElement.addEventListener('keydown', disablePaste);
    return () => editorElement.removeEventListener('keydown', disablePaste);
  }, []);

  return (
    <div id="editor" className="overlay rounded-b-[20px] overflow-hidden w-full h-full shadow-4xl">
      <Editor
        key={language}
        width={`100%`}
        language={language || "javascript"}
        value={code}
        theme={theme}
        defaultValue="// some comment"
        onChange={onChange}
        options={{
          contextmenu: !inFrame || developmentFlag,
          minimap : { enabled: false },
          lineHeight: 20,
        }}
      />
    </div>
  );
};
export default CodeEditorWindow;

